export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/workspace/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/bulk-jobs',
    /* internal name: '/bulk-jobs' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bulk-jobs/',
        component: () => import('/workspace/src/pages/bulk-jobs/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/files',
    /* internal name: '/files' */
    /* no component */
    children: [
      {
        path: '',
        name: '/files/',
        component: () => import('/workspace/src/pages/files/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/liability-forms',
    /* internal name: '/liability-forms' */
    /* no component */
    children: [
      {
        path: '',
        name: '/liability-forms/',
        component: () => import('/workspace/src/pages/liability-forms/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/log-in',
    name: '/log-in',
    component: () => import('/workspace/src/pages/log-in.vue'),
    /* no children */
  },
  {
    path: '/pages',
    /* internal name: '/pages' */
    /* no component */
    children: [
      {
        path: '',
        name: '/pages/',
        component: () => import('/workspace/src/pages/pages/index.vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/pages/new',
        component: () => import('/workspace/src/pages/pages/new.vue'),
        /* no children */
      },
      {
        path: 'new2',
        name: '/pages/new2',
        component: () => import('/workspace/src/pages/pages/new2.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/power-data',
    /* internal name: '/power-data' */
    /* no component */
    children: [
      {
        path: 'members',
        /* internal name: '/power-data/members' */
        /* no component */
        children: [
          {
            path: '',
            name: '/power-data/members/',
            component: () => import('/workspace/src/pages/power-data/members/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/power-data/members/[id]',
            component: () => import('/workspace/src/pages/power-data/members/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'retailers',
        /* internal name: '/power-data/retailers' */
        /* no component */
        children: [
          {
            path: '',
            name: '/power-data/retailers/',
            component: () => import('/workspace/src/pages/power-data/retailers/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/power-data/retailers/[id]',
            component: () => import('/workspace/src/pages/power-data/retailers/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'shows',
        /* internal name: '/power-data/shows' */
        /* no component */
        children: [
          {
            path: '',
            name: '/power-data/shows/',
            component: () => import('/workspace/src/pages/power-data/shows/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/power-data/shows/[id]',
            component: () => import('/workspace/src/pages/power-data/shows/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: 'actions',
        name: '/settings/actions',
        component: () => import('/workspace/src/pages/settings/actions.vue'),
        /* no children */
      },
      {
        path: 'board-members',
        /* internal name: '/settings/board-members' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/board-members/',
            component: () => import('/workspace/src/pages/settings/board-members/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: '/settings/board-members/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/board-members/[id]/',
                component: () => import('/workspace/src/pages/settings/board-members/[id]/index.vue'),
                /* no children */
              },
              {
                path: 'edit',
                name: '/settings/board-members/[id]/edit',
                component: () => import('/workspace/src/pages/settings/board-members/[id]/edit.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'new',
            name: '/settings/board-members/new',
            component: () => import('/workspace/src/pages/settings/board-members/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'global-settings',
        name: '/settings/global-settings',
        component: () => import('/workspace/src/pages/settings/global-settings.vue'),
        /* no children */
      },
      {
        path: 'member-brands',
        /* internal name: '/settings/member-brands' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/member-brands/',
            component: () => import('/workspace/src/pages/settings/member-brands/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/member-brands/[id]',
            component: () => import('/workspace/src/pages/settings/member-brands/[id].vue'),
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/member-brands/new',
            component: () => import('/workspace/src/pages/settings/member-brands/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'show-regions',
        /* internal name: '/settings/show-regions' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/show-regions/',
            component: () => import('/workspace/src/pages/settings/show-regions/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: '/settings/show-regions/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/show-regions/[id]/',
                component: () => import('/workspace/src/pages/settings/show-regions/[id]/index.vue'),
                /* no children */
              },
              {
                path: 'edit',
                name: '/settings/show-regions/[id]/edit',
                component: () => import('/workspace/src/pages/settings/show-regions/[id]/edit.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'new',
            name: '/settings/show-regions/new',
            component: () => import('/workspace/src/pages/settings/show-regions/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'show-types',
        /* internal name: '/settings/show-types' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/show-types/',
            component: () => import('/workspace/src/pages/settings/show-types/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: '/settings/show-types/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/show-types/[id]/',
                component: () => import('/workspace/src/pages/settings/show-types/[id]/index.vue'),
                /* no children */
              },
              {
                path: 'edit',
                name: '/settings/show-types/[id]/edit',
                component: () => import('/workspace/src/pages/settings/show-types/[id]/edit.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'new',
            name: '/settings/show-types/new',
            component: () => import('/workspace/src/pages/settings/show-types/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'show-years',
        /* internal name: '/settings/show-years' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/show-years/',
            component: () => import('/workspace/src/pages/settings/show-years/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: '/settings/show-years/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/show-years/[id]/',
                component: () => import('/workspace/src/pages/settings/show-years/[id]/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'new',
            name: '/settings/show-years/new',
            component: () => import('/workspace/src/pages/settings/show-years/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'staff',
        /* internal name: '/settings/staff' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/staff/',
            component: () => import('/workspace/src/pages/settings/staff/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: '/settings/staff/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/staff/[id]/',
                component: () => import('/workspace/src/pages/settings/staff/[id]/index.vue'),
                /* no children */
              },
              {
                path: 'edit',
                name: '/settings/staff/[id]/edit',
                component: () => import('/workspace/src/pages/settings/staff/[id]/edit.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'new',
            name: '/settings/staff/new',
            component: () => import('/workspace/src/pages/settings/staff/new.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'system-emails',
        /* internal name: '/settings/system-emails' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/system-emails/',
            component: () => import('/workspace/src/pages/settings/system-emails/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/system-emails/[id]',
            component: () => import('/workspace/src/pages/settings/system-emails/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/shows',
    /* internal name: '/shows' */
    /* no component */
    children: [
      {
        path: '',
        name: '/shows/',
        component: () => import('/workspace/src/pages/shows/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/shows/[id]' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: '/shows/[id]/edit',
            component: () => import('/workspace/src/pages/shows/[id]/edit.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

